import React from 'react'

// material ui
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'

const ConfirmationRequired = props => {
  const { camper } = props
  return (
    <Typography mb={4} variant='body1' align='center'>
      Please{' '}
      <Link
        component={RouterLink}
        underline='always'
        to={`/campers/${camper.id}/edit`}
      >
        confirm your returning camper
      </Link>{' '}
      before purchasing days.
    </Typography>
  )
}

export default ConfirmationRequired
